export const selectActiveForm = ({ forms }) => {
  const { activeFormId } = forms

  return forms[activeFormId]
}
